import React from "react";

import { Divider } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

const Tick = ({ height, ...props }) => {
  const theme = useTheme();
  const style = {
    height: height,
    width: 1,
    backgroundColor: theme.palette.type === "dark" ? theme.palette.text.secondary : "rgba(0, 0, 0, 0.5)",
  };

  return <Divider style={style} {...props} />;
};

export default Tick;
